import { STATUS, TYPES } from "@/lib/format";

export const StatusBadge = ({ status }) => {
  const s = STATUS[status] || { label: status, cls: "bg-slate-50 text-slate-600 border-slate-200" };
  return (
    <span data-testid={`status-badge-${status}`} className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wider ${s.cls}`}>
      {s.label}
    </span>
  );
};

export const TypeTag = ({ type }) => (
  <span className="inline-flex items-center rounded-md bg-slate-100 px-2 py-0.5 text-xs font-medium text-slate-700">{TYPES[type] || type}</span>
);

export const PageHead = ({ title, sub, children }) => (
  <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between rise">
    <div>
      <h1 className="text-3xl font-extrabold sm:text-4xl">{title}</h1>
      {sub && <p className="mt-1 text-sm text-slate-500">{sub}</p>}
    </div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);

export const Empty = ({ icon: Icon, title, text, testid }) => (
  <div data-testid={testid} className="rounded-2xl border border-dashed border-slate-300 bg-white/60 px-6 py-12 text-center">
    {Icon && <Icon className="mx-auto mb-3 h-8 w-8 text-slate-400" />}
    <p className="font-display text-lg font-bold">{title}</p>
    {text && <p className="mt-1 text-sm text-slate-500">{text}</p>}
  </div>
);
